import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './Auth.css';

const CONTACT_EMAIL = 'contact@smarteaming.com';
const CONTACT_PHONE = '+32 488 55 75 61';

const MainPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="auth-shell">
      <div className="auth-card">
          <p className="eyebrow">{t('auth_landing_eyebrow')}</p>
          <h1>
            <Trans i18nKey="auth_landing_title_html" components={{ em: <em className="serif-italic accent-text" /> }} />
          </h1>
          <p className="auth-sub">{t('auth_landing_sub')}</p>

          <button type="button" className="btn-submit" onClick={() => navigate('/signin')}>
            {t('Sign In')}
          </button>

          <div className="auth-sep"><span>{t('or')}</span></div>

          <button type="button" className="btn-secondary" onClick={() => navigate('/signup')}>
            {t('auth_create_account')}
          </button>

          <p className="auth-foot">
            {t('auth_demo_video_soon')}
            <br />
            {t('auth_demo_custom')}{' '}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
            {' · '}
            <a href={`tel:${CONTACT_PHONE.replace(/\s/g, '')}`}>{CONTACT_PHONE}</a>
          </p>
        </div>
    </div>
  );
};

export default MainPage;
